import { render, staticRenderFns } from "./RsaDynamicBodyAreaComponents.vue?vue&type=template&id=5d0d6146&scoped=true"
import script from "./RsaDynamicBodyAreaComponents.vue?vue&type=script&lang=js"
export * from "./RsaDynamicBodyAreaComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0d6146",
  null
  
)

export default component.exports